//import _ from 'lodash';

import * as constants from './Agreement.constants';
import * as services from './Agreement.service';

const state = {
  res_getAgreementCheck: {},

  res_makeAgreementSign: false,

  res_getAgreement: {},

  isRequest: false,
};

const mutations = {
  [constants.GET_AGREEMENT_CHECK_SUCCESS](state, res_getAgreementCheck) {
    if (undefined !== res_getAgreementCheck && null !== res_getAgreementCheck) {
      state.res_getAgreementCheck = res_getAgreementCheck;
    }
  },

  [constants.MAKE_AGREEMENT_SIGN_SUCCESS](state, res_makeAgreementSign) {
    if (undefined !== res_makeAgreementSign && null !== res_makeAgreementSign) {
      state.res_makeAgreementSign = res_makeAgreementSign;
    }
  },

  [constants.GET_AGREEMENT_SUCCESS](state, res_getAgreement) {
    if (undefined !== res_getAgreement && null !== res_getAgreement) {
      state.res_getAgreement = res_getAgreement;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, isRequest) {
    state.isRequest = isRequest;
  },
};

const actions = {
  async getAgreementCheck({ commit }, payload) {
    const res = await services.getAgreementCheck(payload);
    commit(constants.GET_AGREEMENT_CHECK_SUCCESS, res.data.data);
  },

  async makeAgreementSign({ commit, dispatch }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makeAgreementSign(payload);
    commit(constants.MAKE_AGREEMENT_SIGN_SUCCESS, res.data.data);
    await dispatch('getAgreementCheck', payload);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getCourseAgreement({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getCourseAgreement(payload);
    commit(constants.GET_AGREEMENT_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getOrderAgreement({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getOrderAgreement(payload);
    commit(constants.GET_AGREEMENT_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
